import { render, staticRenderFns } from "./TicketCodeLookupForm.vue?vue&type=template&id=0008c70a&scoped=true"
import script from "./TicketCodeLookupForm.vue?vue&type=script&lang=js"
export * from "./TicketCodeLookupForm.vue?vue&type=script&lang=js"
import style0 from "./TicketCodeLookupForm.vue?vue&type=style&index=0&id=0008c70a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0008c70a",
  null
  
)

export default component.exports